export default "__VITE_ASSET__BTZMz_t7__"